import React from 'react'
import { DASHBOARD_CONTEXT } from '@trustero/trustero-api-web/lib/dashboard/dashboard_pb'
import { FilterName, FilterParam } from '../../../../FilterBar.types'
import { DashboardDimensionFilterDropdown } from '../DashboardDimensionFilterDropdown'

export const DashboardTPUpdateCategoryFilterDropdown = ({
  isNested = false,
  dashboardContext,
  dashboardName,
}: {
  isNested?: boolean
  dashboardContext?: DASHBOARD_CONTEXT
  dashboardName?: string
}): JSX.Element | null =>
  dashboardContext !== undefined && dashboardName !== undefined ? (
    <DashboardDimensionFilterDropdown
      filterParam={FilterParam.DASHBOARD_TP_UPDATE_CATEGORY_DIMENSION}
      filterName={FilterName.DASHBOARD_TP_UPDATE_CATEGORY_DIMENSION}
      dashboardContext={dashboardContext}
      dashboardName={dashboardName}
      dimension="category"
      isNested={isNested}
    />
  ) : null
